<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="text-3xl text-white self-center"><b>
                    {{ aprRecord?.stringShortName }}
                </b></div>
        </div>

        <div class="p-12">
            <apr-form [form]="aprForm"> </apr-form>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="back()">
            Back
        </button>
        <button class="btn btn-outline btn-default" [disabled]="!hasFormChanged()" (click)="createApr()">
            Save
        </button>
    </div>
</div>